module.exports = __webpack_public_path__ + "static/media/mahameru3.6ab266bb.jpg";